import { Button, Card, CardBody, CardHeader, Col, Row } from 'reactstrap';

import HotTimeClock from './../../../../../../assets/custom/hot-time-clock.gif';
import SufficientTimeClock from './../../../../../../assets/custom/sufficient-time-clock.gif';
import WarningTimeClock from './../../../../../../assets/custom/warning-time-clock.gif';

const CardView = ({ data, isMultiSelectable, schema, currentSelectedBooking, setCurrentSelectedBooking, setCurrentActiveBookingAction }) => {
  console.log('hello card view data', schema);
  return (
    <div className="horizontal-scrollor">
      <div className="booking-data-card-container">
        {data?.map((result, index) => (
          <>
            <Card className={`booking-card ${currentSelectedBooking?.[0]?.bookingId === result?.bookingId ? 'active' : ''}`} key={index}>
              <CardHeader>
                <div className="booking-card-header">
                  <div className="booking-id-details">
                    <p>
                      Booking Id -{' '}
                      <span
                        className=""
                        style={{ color: result?.rowColorCode ? result?.rowColorCode : '#3577f1' }}
                        onClick={() => setCurrentSelectedBooking([{ ...result }])}
                      >
                        {result?.bookingId || ''}
                      </span>
                    </p>
                  </div>
                  <div
                    className="booking-tat-details"
                    style={{
                      backgroundColor: `${result?.tat?.color || 'white'}`,
                    }}
                  >
                    {result?.tat?.color === '#FCE2E2' && <img src={HotTimeClock} className="remaining-clock-time" />}
                    {result?.tat?.color === '#FFF5E7' && <img src={WarningTimeClock} className="remaining-clock-time" />}
                    {result?.tat?.color === '#E5EBFF' && <img src={SufficientTimeClock} className="remaining-clock-time" />}

                    <p> {`${result?.tat?.value} ${result?.tat?.unit} Remaining`}</p>
                  </div>
                </div>
              </CardHeader>

              <CardBody className="booking-card-body">
                <Row>
                  {schema?.map((cSchema, index) => {
                    return (
                      <Col md={`${cSchema?.metadata?.widthPercentage === 50 ? 6 : 12}`} className="mb-3" key={index}>
                        <div className="booking-details-heading">{cSchema?.label || '-'}</div>
                        <div className="booking-details-data">{result?.[cSchema?.key]}</div>
                      </Col>
                    );
                  })}
                </Row>

                <Row>
                  <Col md={12} className="text-center mt-3">
                    <div className="d-flex gap-2 flex-wrap justify-content-center">
                      {result?.actions?.includes(`assign_to_me`) && (
                        <Button
                          className="customized-btn"
                          color="primary"
                          onClick={() => {
                            setCurrentSelectedBooking([{ ...result }]);
                            setCurrentActiveBookingAction(`assign_to_me`);
                          }}
                        >
                          Assign to Me
                        </Button>
                      )}

                      {result?.actions?.includes(`notify_customer`) && (
                        <Button
                          className="customized-btn reject"
                          color="primary"
                          onClick={() => {
                            setCurrentSelectedBooking([{ ...result }]);
                            setCurrentActiveBookingAction(`notify_customer`);
                          }}
                        >
                          Notify Customer
                        </Button>
                      )}

                      {result?.actions?.includes(`assign_to_vendor`) && (
                        <Button
                          className="customized-btn"
                          color="success"
                          onClick={() => {
                            setCurrentSelectedBooking([{ ...result }]);
                            setCurrentActiveBookingAction(`assign_to_vendor`);
                          }}
                        >
                          Assign to Vendor
                        </Button>
                      )}

                      {result?.actions?.includes(`reassign_vendor`) && (
                        <Button
                          className="customized-btn"
                          color="success"
                          onClick={() => {
                            setCurrentSelectedBooking([{ ...result }]);
                            setCurrentActiveBookingAction(`reassign_vendor`);
                          }}
                        >
                          Reassign Vendor
                        </Button>
                      )}

                      {result?.actions?.includes(`assign_chauffeur`) && (
                        <Button
                          className="customized-btn"
                          color="success"
                          onClick={() => {
                            setCurrentSelectedBooking([{ ...result }]);
                            setCurrentActiveBookingAction(`assign_chauffeur`);
                          }}
                        >
                          Assign Chauffeur
                        </Button>
                      )}

                      {result?.actions?.includes(`change_chauffeur`) && (
                        <Button
                          className="customized-btn"
                          color="success"
                          onClick={() => {
                            setCurrentSelectedBooking([{ ...result }]);
                            setCurrentActiveBookingAction(`change_chauffeur`);
                          }}
                        >
                          Change Chauffeur
                        </Button>
                      )}

                      {result?.actions?.includes(`complete_booking`) && (
                        <Button
                          className="customized-btn"
                          color="success"
                          onClick={() => {
                            setCurrentSelectedBooking([{ ...result }]);
                            setCurrentActiveBookingAction(`complete_booking`);
                          }}
                        >
                          Mark As Complete
                        </Button>
                      )}

                      {result?.actions?.includes(`raise_a_dispute`) && (
                        <Button
                          className="customized-btn danger"
                          color="danger"
                          onClick={() => {
                            setCurrentSelectedBooking([{ ...result }]);
                            setCurrentActiveBookingAction(`raise_a_dispute`);
                          }}
                        >
                          Raise Dispute
                        </Button>
                      )}

                      {result?.actions?.includes(`vendor_accept`) && (
                        <Button
                          className="customized-btn"
                          color="success"
                          onClick={() => {
                            setCurrentSelectedBooking([{ ...result }]);
                            setCurrentActiveBookingAction(`vendor_accept`);
                          }}
                        >
                          Confirm
                        </Button>
                      )}

                      {result?.actions?.includes(`vendor_declined`) && (
                        <Button
                          className="customized-btn"
                          color="danger"
                          onClick={() => {
                            setCurrentSelectedBooking([{ ...result }]);
                            setCurrentActiveBookingAction(`vendor_declined`);
                          }}
                        >
                          Decline
                        </Button>
                      )}

                      {result?.actions?.includes(`reject-slot`) && (
                        <Button
                          className="customized-btn danger"
                          onClick={() => {
                            setCurrentSelectedBooking([{ ...result }]);
                            setCurrentActiveBookingAction(`reject-slot`);
                          }}
                        >
                          Reject Slot
                        </Button>
                      )}

                      {result?.actions?.includes(`approve`) && (
                        <Button
                          className="customized-btn"
                          color="success"
                          onClick={() => {
                            setCurrentSelectedBooking([{ ...result }]);
                            setCurrentActiveBookingAction(`approval`);
                          }}
                        >
                          Approve
                        </Button>
                      )}

                      {result?.actions?.includes(`reject`) && (
                        <Button
                          className="customized-btn danger"
                          color="primary"
                          onClick={() => {
                            setCurrentSelectedBooking([{ ...result }]);
                            setCurrentActiveBookingAction(`reject`);
                          }}
                        >
                          Reject
                        </Button>
                      )}

                      {result?.actions?.includes(`notify_vendor`) && (
                        <Button
                          className="customized-btn reject"
                          color="primary"
                          onClick={() => {
                            setCurrentSelectedBooking([{ ...result }]);
                            setCurrentActiveBookingAction(`notify_vendor`);
                          }}
                        >
                          Notify Golf Course
                        </Button>
                      )}

                      {result?.actions?.includes(`cancelled_with_vendor`) && (
                        <Button
                          className="customized-btn reject"
                          color="primary"
                          onClick={() => {
                            setCurrentSelectedBooking([{ ...result }]);
                            setCurrentActiveBookingAction(`cancelled_with_vendor`);
                          }}
                        >
                          Cancelled With Vendor
                        </Button>
                      )}
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </>
        ))}
      </div>
    </div>
  );
};

export default CardView;
